import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';

import ChronologyDetailsTab from './tabs/ChronologyDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ChronologyDetailsTab {...props} />
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_chro_uid', filt_clause: 'equals', filt_value: model.chro_uid }]}
			/>
		)
	}
];

export default tabs;
